<template>
<div class="Resume" :class="{ 'is-loading': loading }">
  <Hero title="Resume" :pictures="[ 'bromo.jpg', 'JZG.jpg' ]" :height="75" />
  <Duo>
    <template #left>
      <p class="Resume__pdfText">
        As simple as it gets, my resume available as a plain old PDF file
      </p>
    </template>
    <template #right>
      <a class="Resume__pdf" href="/cv.pdf" target="_blank">
        <img src="../assets/pdf.svg" class="Resume__pdfLogo" alt="pdf_logo"/>
      </a>
    </template>
  </Duo>
  <transition name="fade">
    <div class="Resume__loader" v-if="loading">
      <img src="../assets/triangles-loader.svg" alt="">
    </div>    
  </transition>  
  <div v-if="!loading">
    <Skills v-for="(type, index) in skills" 
          :key="type.title" 
          :title="type.title" 
          :technos="type.technos" 
          :bar-style="type.barStyle" 
          :transition-name="index%2 === 0 ? 'slide' : 'slide-left'"/>

    <div class="Resume__experiencesTitle">Work experiences</div>
    <Duo v-for="(xp, index) in orderedExperiences" 
        :key="xp" 
        v-intersect="{handler: (a, b, isIntersecting) => handleIntersect(isIntersecting, index), options: {threshold: 0.9}}">
      <template v-slot:[getSide(index)]>
        <transition :name="getSide(index) === 'right' ? 'slide' : 'slide-left'" appear>
          <div class="Resume__imageContainer" v-if="xp.isVisible">
            <img :src="`/img${xp.logo}`" :alt="xp.logo">
          </div>
        </transition>
      </template>
      <template v-slot:[getSide(index+1)]>
        <transition :name="getSide(index) === 'right' ? 'slide-left' : 'slide'" appear>
          <Experience v-bind="xp" v-if="xp.isVisible"/>
        </transition>
      </template>
    </Duo>
  </div>
</div>
</template>

<script>
import Hero from '@/components/Hero'
import Duo from '@/components/Duo'
import Skills from '@/components/Skills'
import Experience from '@/components/Experience'
import useSkills from '@/composables/useSkills'
import useExperiences from '@/composables/useExperiences'
import { computed } from 'vue'

export default {
    name: 'Resume',
    components: {
        Hero,
        Duo,
        Skills,
        Experience
    },
    setup () {
      const { getSkills } = useSkills()
      const { skills, skillsLoading } = getSkills()

      const { getExperiences } = useExperiences()
      const { experiences, experiencesLoading } = getExperiences()

      const loading = computed(() => skillsLoading.value && experiencesLoading.value)
      
      const orderedExperiences = computed(() => {
        if (experiences.value) {
          return experiences.value.slice().reverse()
        }
        return []
      })

      function getSide (i) {
        return i%2 === 0 ? 'left' : 'right'
      }
      function handleIntersect (isIntersecting, index) {
        if (isIntersecting) {
          orderedExperiences.value[index].isVisible = true
        }
      }

      return { skills, orderedExperiences, getSide, handleIntersect, loading }
    }
}
</script>

<style lang="scss" scoped>
  .Resume {
    overflow-x: hidden;

    &__pdf {
        display: block;
        border: 8px solid black;
        border-radius: 50%;
        padding: 40px;
        width: fit-content;
        margin: auto;

        &:hover {
          background-color: #aaa;
          color: #eee;
          border-color: #ccc;
        }

      &Text {
        font-size: 2em;
        height: 100%;
        display: flex;
        align-items: center;
      }

      &Logo {
        width: 150px;

        @media (min-width: 460px) {
          width: 200px;
        }
      }
    }

    &__imageContainer {
      display: flex;
      align-items: center;
      height: 100%;
      justify-content: center;

      img {
        width: 75%;
      }
    }

    &__experiencesTitle {
      background: linear-gradient(141deg,#0fb8ad,#1fc8db 51%,#2cb5e8 75%);
      text-align: start;
      padding-left: 30%;
      padding: 3vh 5vw;
      color: #fff;
      font-size: 3em;
      font-variant: small-caps;
    }

    &__loader {
      position: absolute;
      left: calc(50% - 100px);
    }

    &.is-loading {
      padding-bottom: 300px;
    }
  }
</style>